// frontend/admin-portal/src/components/settings/SettingsPanel.jsx
import React from "react";

export default function SettingsPanel({ children }) {
  return <div className="fh-settings-panel">{children}</div>;
}
